import React from 'react';
//import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
//import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import retrieveCompanyData from 'views/Expo/retrieveCompanyData';


const Hero = ({secondState, handleCurrentStep}) => {

  if (secondState) {
  retrieveCompanyData[0].email = secondState.designation;
  retrieveCompanyData[0].status = secondState.designation1;

  retrieveCompanyData[1].email = secondState.company;
  retrieveCompanyData[1].status = secondState.company1;

  retrieveCompanyData[2].email = secondState.companyAdd;
  retrieveCompanyData[2].status = secondState.companyAdd1;
  }

  return (
    
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="">
      <TableHead sx={{ bgcolor:'#377dff'}}>
            <TableRow>
              <TableCell>
                <Typography
                 
                  fontWeight={700}
                  // sx={{ textTransform: 'uppercase' }}
                >
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  color={'white'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                  marginLeft={20}
                >
                  Company Details
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  
                </Typography>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
        <TableBody>
          {retrieveCompanyData.map((item, i) => (
            <TableRow
              key={i}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                <Typography variant={'subtitle2'} fontWeight={700}>
                  {item.name}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color={'text.secondary'} variant={'subtitle2'}>
                  {item.email}
                </Typography>
              </TableCell>
              <TableCell>
              <Typography variant={'subtitle2'} fontWeight={700}>
                  {item.title}
                </Typography>
              </TableCell>
              <TableCell>
              <Typography color={'text.secondary'} variant={'subtitle2'}>
                  {item.status}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color={'text.secondary'} variant={'subtitle2'}>
                  {item.role}
                </Typography>
              </TableCell> 
              <TableCell>
                <Typography
                  color={'primary'}
                  variant={'subtitle2'}
                  fontWeight={700}
                  sx={{ cursor: 'pointer' }}
                >
                    
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    
  );
};





export default Hero;